import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
   RouterStateSnapshot } from '@angular/router';
import { DialogService } from 'src/app/services/dialog.service';
import { TranslationService } from 'src/app/services/translation.service';
import { AuthService } from '../../services/auth.service';
import { CRUDAction, PermissionType } from '../enums';
import * as fromApp from '../../store/app.reducer';
import * as AuthSelectors from '../../store/selectors/auth.selector';
import { Store } from '@ngrx/store';
import { map, take } from 'rxjs/operators';
import { NavController } from '@ionic/angular';

@Injectable({ providedIn: 'root' })
export class AuthorizationGuard  {
  constructor(
    private authService: AuthService,
    private dialogService: DialogService,
    private translationService: TranslationService,
    private store: Store<fromApp.AppState>,
    private navController: NavController
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    if (
      this.authService.userIsAuthenticated &&
      this.authService.userIsAuthorized(
        route.data.permissionType as PermissionType,
        route.data.permissionId as number,
        route.data.crudAction as CRUDAction
      )
    ) {
      return true;
    } else {
      if (this.authService.userIsAuthenticated) {
        void this.dialogService.infoAlert(
          this.translationService.translate('COMMON.PAGE_ACCESS_DENIED')
        );
      }

      return false;
    }
  }
}
